module.exports = __webpack_public_path__ + "static/img/astronaut.6b2c82b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404/astronaut.svg
// module id = nZGP
// module chunks = 1